export type BailEstimate = {
  premium: number;
  filing: number;
  total: number;
};

export const PREMIUM_RATE = 0.15;
export const PREMIUM_MINIMUM = 50;
export const FILING_FEE_PER_CASE = 50;

/** Nevada (NRS 697.300): premium = greater of 15% of bail or $50, plus $50 jail filing fee per case number. */
export function estimateBail(bailAmount: number, caseCount: number): BailEstimate {
  const cases = Math.max(1, Math.floor(caseCount || 1));
  if (!bailAmount || bailAmount <= 0) {
    return { premium: 0, filing: 0, total: 0 };
  }
  const premium = Math.max(bailAmount * PREMIUM_RATE, PREMIUM_MINIMUM);
  const filing = FILING_FEE_PER_CASE * cases;
  return { premium, filing, total: premium + filing };
}

export function formatCurrency(value: number, withCents = true): string {
  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: withCents ? 2 : 0,
    maximumFractionDigits: withCents ? 2 : 0,
  });
}
